import * as React from 'react';
import {observer} from "mobx-react-lite";
import WorstIp from "./Stats/WorstIp";
import WorstCountry from "./Stats/WorstCountry";
import HotIocs from "./Stats/HotIoc";
import {Carousel} from "react-bootstrap";


const Stats = observer(function Stats(props: any) {
    return <Carousel slide={false}>
        <Carousel.Item>
            <WorstIp store={props.worstIpStore}/>
        </Carousel.Item>
        <Carousel.Item>
            <WorstCountry store={props.worstCountryStore}/>
        </Carousel.Item>
        <Carousel.Item>
            <HotIocs store={props.hotIocStore}/>
        </Carousel.Item>
    </Carousel>
});

export default Stats